export { default } from './TextArea';
export type { TextAreaProps } from './TextArea';
